export const GET_CAREER_LISTING = 'GET_CAREER_LISTING';
export const GET_JOB_DETAIL = 'GET_JOB_DETAIL';
